module.exports = __webpack_public_path__ + "img/logo_blue.de727ab1.png";